module.exports = __webpack_public_path__ + "static/media/wordpress.5719e480.png";